
<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="500px" transition="dialog-transition" >
    <template v-slot:activator='{on}'>
      <v-btn :disabled="!can_edit" v-on="on" style="position: relative; left: 135px; top: 105px; float: left" fab x-small class="elevation-2" color="primary"><v-icon small>mdi-pencil</v-icon></v-btn>
    </template>

    <v-card style="border-radius: 5px" v-if="dialog">
      <v-card-title primary-title>
        <div class="headline mb-0">{{this.$route.name == 'Account' ? 'Foto de perfil' : 'Logo da Empresa'}}</div>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="pa-6">
        <v-file-input accept="image/*" label='Logo' show-size v-if="false"
          v-model="image" :rules="required"
          @change="handleChangeImage" 
          @click:clear="clearImage" 
          ref="file_input"
          style="display: none"
        ></v-file-input>
        
        <input type="file" accept="image/*" style="display: none" id="file" ref="file" @change="handleChangeImage()">

        <v-col align="center" v-if="image_to_show">
          <v-img v-if="file_kind.includes('image')" :src="image_to_show" class="my-3" height="250" />
          <iframe width="500" height="500" v-if="!file_kind.includes('image')" :src="image_to_show" frameborder="0" ></iframe>
        </v-col>

        <!-- <attach-doc btn_text='foto' :existing_doc="employee.document.document" @donePhoto="handleDonePhoto" @removePhoto="handleRemovePhoto"></attach-doc> -->
        <v-col cols='12' class="pa-0" align="center">
          <v-btn dense small color="primary" @click="$refs.file.click()">escolher</v-btn>
          <v-btn v-if="has_image" dense small color="error" @click="submitEdit(true)" class="ml-2">limpar</v-btn>
        </v-col>

      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn dense small @click="dialog = false" text color="error">Cancelar</v-btn>
        <v-btn dense small @click="submitEdit()" color="success">Salvar</v-btn>
      </v-card-actions>
    </v-card>

    <dialog-loading v-if="saving" loadingText='Salvando'></dialog-loading>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
// import CitySelection from '../../shared/CitySelection.vue'
// import validations from "@/mixins/validations";
// import http from '@/plugins/axios'
import Api from '@/api/index'
// import AttachDoc from '../../financials/driver/AttachDoc.vue';
import validations from "@/mixins/validations";

export default {
  name: 'DialogEditUserAvatar',
  mixins: [ validations ],
  props: {
    can_edit: {
      type: Boolean,
      default: true
    },
  },
  components: {
    // CitySelection,
    // AttachDoc,
  },
  data() {
    return {
      dialog: false,
      employee: {},
      image: null,
      file_local_url: null,
      local_file: {},

      saving: false,
    }
  },
  methods: {
    handleChangeImage(){
      let file = this.$refs.file.files[0]
      this.image = file
      let url = window.URL.createObjectURL(file);
      this.file_local_url = url
    },
    clearImage() {
      this.image = null
      this.file_local_url = null
    },
    setupAvatar() {
      this.clearAvatar()
      let {id, document} = this.activeCompany.included[0].attributes
      document = document || {}
      this.employee = {id, document, document_attributes: {} } 
    },
    clearAvatar(){
      this.employee = {}
    },
    handleDonePhoto(e) {
      this.employee.document_attributes = {...e}
    },
    handleRemovePhoto(){
      this.employee.document_attributes = {
        url_document: null,
        name: null,
        kind: null,
      }
    },
    updateImage(formData){
      console.log(formData)
      this.saving = true
      let noti = {
        type: 'success',
        msg: 'Feito com sucesso'
      }
      if(this.$route.name == 'Account'){
        Api.User.updateAvatar(this.profile.id, formData).then(r => r.data).then(company => {
          this.addNotification(noti)
          setTimeout(() => {
            this.$router.go()
          }, 1200);
        }).catch((err) => {
          noti = {
            type: 'error',
            msg: `Erro: ${err}`
          }
          console.log({err});
          this.addNotification(noti)
        }).finally(()=> {
          this.saving = false
        })
      }else{
        Api.Company.updateLogo(this.activeCompany.id, formData).then(r => r.data).then(company => {
          this.addNotification(noti)
          setTimeout(() => {
            this.$router.go()
          }, 1200);
        }).catch((err) => {
          noti = {
            type: 'error',
            msg: `Erro: ${err}`
          }
          console.log({err});
          this.addNotification(noti)
        }).finally(()=> {
          this.saving = false
        })
      }
    },
    submitEdit(clear_image){
      if (this.image || clear_image){
        let { id, } = this.$route.name == 'Account' ? this.profile : this.activeCompany
        var formData = new FormData();
        if (this.image || clear_image) {
          if(this.$route.name == 'Account'){
            formData.append("user[avatar]", clear_image ? '' : this.image);
          }else{
            formData.append("company[logo]", clear_image ? '' : this.image);
          }
        };
        if(this.$route.name == 'Account'){
            formData.append("user[id]", id);
          }else{
            formData.append("company[id]", id);
          }

        let c = confirm('Deseja salvar alterações?')
        if (c){
          this.updateImage(formData)
        }
      }
    },
    ...mapActions({
      addNotification: 'Notification/add',
      // updateImage: 'employee/updateImage',
      // function: 'Module/action'
    }),
    ...mapMutations({
      // setactiveCompany: 'employee/setactiveCompany',
    })
  },
  computed: {
    has_image(){
      if (this.$route.name == 'MyCompanySettings' && this.activeCompany && this.activeCompany.logo_url){
        return this.activeCompany.logo_url ? true : false
      } else if (this.$route.name == 'Account' && this.profile && this.profile.avatar_url){
        return this.profile.avatar_url ? true : false
      }
    },
    is_readonly() {
      return false 
    },
    preview_logo() {
      if (this.employee.logo_aux){
        return this.employee.logo_aux 
      }
    },
    file_kind(){
      if (this.image){
        return this.image.type
      } else if (this.$route.name == 'MyCompanySettings' && this.activeCompany && this.activeCompany.logo_url){
        return this.activeCompany.logo_kind
      } else if (this.$route.name == 'Account' && this.profile && this.profile.avatar_url){
        return this.profile.avatar_kind
      }
    },
    image_to_show(){
      let img = null;
      if (this.file_local_url) {
        img = this.file_local_url
      } else if (this.$route.name == 'MyCompanySettings' && this.activeCompany && this.activeCompany.logo_url){
        img = this.activeCompany.logo_url
      } else if (this.$route.name == 'Account' && this.profile && this.profile.avatar_url){
        img = this.profile.avatar_url
      }
      return img;
    },
    ...mapState({
      activeCompany: state => state.App.activeCompany,
      profile: state => state.User.user
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
        // this.setupAvatar()
      } else if (nv == false){
        this.clearImage()
        this.clearAvatar()
      }
    }
  },
}
</script>

<style scoped>

</style>